import {MDBRow, MDBCol} from "mdbreact"
import {CustomPrice} from "../../containers/CustomPrices/customPricesSlice"
import {useInternationalization} from "@progress/kendo-react-intl"

const DaysSection = ({customPrice}: {customPrice: CustomPrice}) => {
    const intl = useInternationalization()

    const formatPrice = (price: number | null) =>
        price === 0 || price === null ? (
            <>&nbsp;</>
        ) : (
            intl.formatNumber(price, {style: "currency", minimumFractionDigits: 2})
        )
    return (
        <MDBRow className="mb-2 ps-0 pt-2">
            <MDBCol>
                <MDBRow className=" me-1 ms-0 small">Mon</MDBRow>
                <MDBRow className="pt-2 me-1 ms-0">{formatPrice(customPrice.monday)}</MDBRow>

                <MDBRow className="pt-2 me-1 ms-0 small">Fri</MDBRow>
                <MDBRow className="pt-2 ms-0">{formatPrice(customPrice.friday)} </MDBRow>
            </MDBCol>

            <MDBCol>
                <MDBRow className=" me-1 ms-0 small">Tue</MDBRow>
                <MDBRow className="pt-2 me-1 ms-0">{formatPrice(customPrice.tuesday)}</MDBRow>

                <MDBRow className="pt-2  me-1 ms-0 small">Sat</MDBRow>
                <MDBRow className="pt-2 me-1 ms-0">{formatPrice(customPrice.saturday)}</MDBRow>
            </MDBCol>

            <MDBCol>
                <MDBRow className="me-1 ms-0 small">Wed</MDBRow>
                <MDBRow className="pt-2 me-1 ms-0 ">{formatPrice(customPrice.wednesday)}</MDBRow>

                <MDBRow className="pt-2  me-1 ms-0 small">Sun</MDBRow>
                <MDBRow className="pt-2 me-1 ms-0">{formatPrice(customPrice.sunday)}</MDBRow>
            </MDBCol>

            <MDBCol>
                <MDBRow className=" me-1 ms-0 small">Thu</MDBRow>
                <MDBRow className="pt-2 me-1 ms-0">{formatPrice(customPrice.thursday)}</MDBRow>
            </MDBCol>
        </MDBRow>
    )
}

export default DaysSection
